var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('header',[_c('img',{attrs:{"src":_vm.logoTitle,"alt":""}})]),_c('section',[_c('div',{staticClass:"center"},[_c('div',{staticClass:"centerRight",attrs:{"id":"loginBox"}},[_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }